// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57cbf01d","533":"693be45b"}[chunkId] + ".chunk.js";
};